import React from 'react';

type TestIDFactoryType = (props: any) => string;

export type TestContextProps = { [id: string]: (TestIDFactoryType | string) }

const TestContext = React.createContext<TestContextProps>({});

export default TestContext;
